import { useEffect, useState } from "react";

/**
 * Επιστρέφει `false` στον server και στο ΠΡΩΤΟ client render, και `true` μετά
 * το mount. Χρησιμοποιείται για να εξασφαλίσουμε ότι το αρχικό client render
 * ταιριάζει ακριβώς με το HTML του server (αποφυγή hydration mismatch / React
 * #418), όταν το περιεχόμενο εξαρτάται από δεδομένα που μπορεί να υπάρχουν στο
 * dehydrated cache του client αλλά όχι στη στιγμή του SSR render.
 */
export function useIsHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);
  return hydrated;
}
